import React, { useEffect, useMemo, useState } from "react";
import { isArrayEmpty, isObjectEmpty } from "utils/commonHelper";
import SingleChoiceQuestion from "./questionType/SingleChoiceQuestion";
import MultipleChoiceQuestion from "./questionType/MultipleChoiceQuestion";
import TextQuestion from "./questionType/TextQuestion";
import PictureQuestion from "./questionType/PictureQuestion";
import RankOrderQuestion from "./questionType/RankOrderQuestion";
import SliderQuestion from "./questionType/SliderQuestion";
import RatingQuestion from "./questionType/RatingQuestion";
import { useTranslation } from "react-i18next";

const SurveyPreview = ({
  surveyMcq,
  surveyBlocks,
  ratingSliderMcq,
  titleArray = [],
  showAnswer = false,
}) => {
  // set all value
  const [selectedBlock, setSelectedBlock] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    if (!showAnswer) {
      surveyBlocks?.length > 0 && setSelectedBlock(surveyBlocks[0]?.name);
    } else {
      surveyBlocks?.length > 0 && setSelectedBlock(surveyBlocks[0]);
    }
  }, [showAnswer]);

  const [allPrevQuestionCount, setAllPrevQuestionCount] = useState(0);

  // useEffect for get all question count before selected block
  useEffect(() => {
    if (!showAnswer) {
      let count = 0;
      let currentIndex = surveyBlocks?.findIndex(
        (el) => el?.name === selectedBlock
      );

      for (let i = 0; i < currentIndex; i++) {
        count = count + surveyBlocks[i]?.totalQuestion;
      }
      setAllPrevQuestionCount(count);
    }
  }, [selectedBlock, surveyBlocks, showAnswer]);

  // Handle Block Click
  const handleBlockClick = (blockName) => {
    setSelectedBlock(blockName);
  };

  const getSurveyQuestion = (data, index, showAnswer) => {
    if (!data || isObjectEmpty(data) || !data.questionType) {
      return null; // Return `null` for proper JSX rendering
    }
    const surveyQuestion = {
      single: (
        <SingleChoiceQuestion
          data={data}
          index={index}
          showAnswer={showAnswer}
          prevCount={allPrevQuestionCount || 0}
        />
      ),
      multiple: (
        <MultipleChoiceQuestion
          data={data}
          index={index}
          showAnswer={showAnswer}
          prevCount={allPrevQuestionCount}
        />
      ),
      text: (
        <TextQuestion
          data={data}
          index={index}
          showAnswer={showAnswer}
          prevCount={allPrevQuestionCount}
        />
      ),
      image: (
        <PictureQuestion
          data={data}
          index={index}
          showAnswer={showAnswer}
          prevCount={allPrevQuestionCount}
        />
      ),
      rankorder: (
        <RankOrderQuestion
          data={data}
          index={index}
          showAnswer={showAnswer}
          prevCount={allPrevQuestionCount}
        />
      ),
      slider: (
        <SliderQuestion
          data={data}
          index={index}
          showAnswer={showAnswer}
          prevCount={allPrevQuestionCount}
        />
      ),
      rating: (
        <RatingQuestion
          data={data}
          index={index}
          showAnswer={showAnswer}
          prevCount={allPrevQuestionCount}
        />
      ),
    };

    let selectedSurveyQuestion = data?.questionType || "";

    // Handle special case for `multiple` with `optionType`

    if (selectedSurveyQuestion === "multiple" && data?.setting?.optionType) {
      selectedSurveyQuestion = data.setting.optionType;
    }

    // Return the matching component or null if not found
    return surveyQuestion[selectedSurveyQuestion] || null;
  };

  //*************************** Handle All HTML CODE **********************//
  return (
    <div className="survey_detail">
      <div className="_card">
        <ul className="tab_button">
          {!showAnswer
            ? surveyBlocks?.length > 0 &&
              surveyBlocks?.map((blockName, index) => {
                return (
                  <li key={`${blockName}-${index}`}>
                    <button
                      type="button"
                      onClick={() => handleBlockClick(blockName?.name)}
                      className={`book_number ${
                        selectedBlock === blockName?.name ? "active" : ""
                      }`}
                    >
                      {t(`CUSTOMIZATION_QUESTION.${blockName?.name}`)}
                    </button>
                  </li>
                );
              })
            : surveyBlocks?.length > 0 &&
              surveyBlocks?.map((blockName, index) => {
                return (
                  <li key={`${blockName}-${index}`}>
                    <button
                      type="button"
                      onClick={() => handleBlockClick(blockName)}
                      className={`book_number ${
                        selectedBlock === blockName ? "active" : ""
                      }`}
                    >
                      {t(`CUSTOMIZATION_QUESTION.${blockName}`)}
                    </button>
                  </li>
                );
              })}
        </ul>
        {!showAnswer && (
          <p className="block_title">
            {/* <b>Title :-</b> */}
            {surveyBlocks?.find((el) => el?.name === selectedBlock)?.title}
          </p>
        )}

        {showAnswer && (
          <p className="block_title">
            {/* <b>Title :-</b> */}
            {titleArray?.find((el) => el?.block === selectedBlock)?.title}
          </p>
        )}

        {!isObjectEmpty(surveyMcq) &&
          !isArrayEmpty(surveyMcq[selectedBlock]) &&
          surveyMcq[selectedBlock]?.map((surveyMcq, index) => {
            return getSurveyQuestion(surveyMcq, index, showAnswer);
          })}
      </div>
    </div>
  );
};

export default SurveyPreview;
